import { render, staticRenderFns } from "./InstitutionDetailsModal.vue?vue&type=template&id=002208cc"
import script from "./InstitutionDetailsModal.vue?vue&type=script&lang=js"
export * from "./InstitutionDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./InstitutionDetailsModal.vue?vue&type=style&index=0&id=002208cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports